import { SalesOrderPeriodActions, SalesOrderPeriodActionTypes } from './sales-order-period.actions';
import { SalesOrderPeriodState, TreatmentType } from '../models/sales-order-period.models';

export const initialState = {};

export const salesOrderPeriodReducer = (
  state: SalesOrderPeriodState = initialState,
  action: SalesOrderPeriodActions,
): SalesOrderPeriodState => {
  switch (action.type) {
  case SalesOrderPeriodActionTypes.SetSalesOrderPeriods: {
    return {
      ...state,
      salesOrderPeriods: action.salesOrderPeriods,
    };
  }

  case SalesOrderPeriodActionTypes.SetPastSalesOrderPeriods: {
    const filteredPeriods = action.pastSalesOrderPeriods.filter(
      (period) => period.periodType === TreatmentType.Fertilization,
    );
    return {
      ...state,
      pastSalesOrderPeriods: filteredPeriods.slice(filteredPeriods.length - 4),
    };
  }
  default:
    return state;
  }
};
